import React, { useEffect, useRef } from "react";
import './DashboardHeroPro.css';
import Chart from "chart.js/auto";
import 'moment/locale/es'; // Configurar locale en español
import userProfile from '../../img/searching.png'; // Ajusta la ruta relativa según sea necesario


const DashboardHeroPro = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    // Datos simulados para el gráfico
    const data = {
        labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio'],
        datasets: [
          {
            label: 'Entradas',
            data: [400, 300, 200, 278, 189, 239, 349],
            borderColor: '#8884d8',
            fill: false,
          },
          {
            label: 'Salidas',
            data: [240, 139, 980, 390, 480, 380, 430],
            borderColor: '#82ca9d',
            fill: false,
          }
        ]
      };

    // Crear gráfico con Chart.js
    const chartInstance = new Chart(ctx, {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Tendencias de Material Reciclado (Entradas/Salidas)'
            }
          }
        }
      });

    return () => {
      chartInstance.destroy();
    };
  }, []);

  return (
    <div class="container-fluid p-0">

    <div class="row mb-2 mb-xl-3">
      <div class="col-auto d-none d-sm-block">
        <h3>Dashboard</h3>
      </div>
  
      <div class="col-auto ms-auto text-end mt-n1">
  
        <div class="dropdown me-2 d-inline-block position-relative">
          <a class="btn btn-light bg-white shadow-sm dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-display="static">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="calendar" class="lucide lucide-calendar align-middle mt-n1">
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            Hoy
          </a>
  
          <div class="dropdown-menu dropdown-menu-end">
            <h6 class="dropdown-header">Acciones</h6>
            <a class="dropdown-item" href="#">Añadir Entrada</a>
            <a class="dropdown-item" href="#">Añadir Salida</a>
            <a class="dropdown-item" href="#">Ver Stock</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Reportes</a>
          </div>
        </div>
  
        <button class="btn btn-primary shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="filter" class="lucide lucide-filter align-middle">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
        </button>
  
        <button class="btn btn-primary shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="refresh-cw" class="lucide lucide-refresh-cw align-middle">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
            <path d="M21 3v5h-5"></path>
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
            <path d="M8 16H3v5"></path>
          </svg>
        </button>
      </div>
    </div>
    
  
    <div class="row">
    <div class="col-md-6 col-xxl-3 d-flex">
        <div class="card illustration flex-fill">
          <div class="card-body p-0 d-flex flex-fill">
            <div class="row g-0 w-100">
              <div class="col-6">
                <div class="illustration-text p-3 m-1">
                  <h4 class="illustration-text">Bienvenido de vuelta, Usuario!</h4>
                  <p class="mb-0">Dashboard de Control</p>
                </div>
              </div>
              <div class="col-6 align-self-end text-end">
              <div>
      <img src={userProfile} alt="User Profile" className="img-fluid illustration-img" />
    </div>                </div>

            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-6 col-xxl-3 d-flex">
        <div class="card flex-fill">
          <div class="card-body">
            <div class="row">
              <div class="col mt-0">
                <h5 class="card-title">Entradas Totales</h5>
              </div>
  
              <div class="col-auto">
                <div class="stat stat-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="inbox" class="lucide lucide-inbox align-middle">
                    <path d="M5 12h14l-1.5 9H6.5l-1.5-9z"></path>
                    <path d="M12 1v6"></path>
                    <path d="M7 4l5-3 5 3"></path>
                  </svg>
                </div>
              </div>
            </div>
            <span class="h1 d-inline-block mt-1 mb-3">1,200 kg</span>
            <div class="mb-0">
              <span class="badge badge-subtle-success me-2"> 10% </span>
              <span class="text-muted">Comparado con la semana pasada</span>
            </div>
          </div>
        </div>
      </div>
  
      <div class="col-md-6 col-xxl-3 d-flex">
        <div class="card flex-fill">
          <div class="card-body">
            <div class="row">
              <div class="col mt-0">
                <h5 class="card-title">Salidas Totales</h5>
              </div>
  
              <div class="col-auto">
                <div class="stat stat-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="box" class="lucide lucide-box align-middle">
                    <path d="M21 16V8a2 2 0 0 0-1-1.73L12 2 4 6.27A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73L12 22l8-4.27A2 2 0 0 0 21 16z"></path>
                    <polyline points="3.27 6.96 12 12 20.73 6.96"></polyline>
                    <line x1="12" y1="22" x2="12" y2="12"></line>
                  </svg>
                </div>
              </div>
            </div>
            <span class="h1 d-inline-block mt-1 mb-3">950 kg</span>
            <div class="mb-0">
              <span class="badge badge-subtle-danger me-2"> -5% </span>
              <span class="text-muted">Comparado con la semana pasada</span>
            </div>
          </div>
        </div>
      </div>
  
      <div class="col-md-6 col-xxl-3 d-flex">
        <div class="card flex-fill">
          <div class="card-body">
            <div class="row">
              <div class="col mt-0">
                <h5 class="card-title">Stock Disponible</h5>
              </div>
  
              <div class="col-auto">
                <div class="stat stat-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="layers" class="lucide lucide-layers align-middle">
                    <path d="M12 2l9 5-9 5-9-5 9-5z"></path>
                    <path d="M3 12l9 5 9-5"></path>
                    <path d="M3 17l9 5 9-5"></path>
                  </svg>
                </div>
              </div>
            </div>
            <span class="h1 d-inline-block mt-1 mb-3">2,500 kg</span>
            <div class="mb-0">
              <span class="badge badge-subtle-success me-2"> 8% </span>
              <span class="text-muted">Comparado con la semana pasada</span>
            </div>
          </div>
        </div>
      </div>
  
      
    </div>
  
    <div class="row">
      <div class="col-12 col-lg-6 d-flex">
        <div class="card flex-fill w-100">
          <div class="card-header">
            <div class="card-actions float-end">
              <div class="dropdown position-relative">
                <a href="#" data-bs-toggle="dropdown" data-bs-display="static">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="more-horizontal" class="lucide lucide-more-horizontal align-middle">
                    <circle cx="12" cy="12" r="1"></circle>
                    <circle cx="19" cy="12" r="1"></circle>
                    <circle cx="5" cy="12" r="1"></circle>
                  </svg>
                </a>
  
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="#">Añadir Entrada</a>
                  <a class="dropdown-item" href="#">Añadir Salida</a>
                  <a class="dropdown-item" href="#">Ver Reporte</a>
                </div>
              </div>
            </div>
            <h5 class="card-title mb-0">Movimientos Recientes</h5>
          </div>
          <div class="card-body px-4">
          <div className="container-fluid p-0">
      {/* Tu contenido adicional del dashboard */}
      <canvas ref={chartRef}></canvas> {/* Asignar el ref al canvas */}
    </div>
          </div>
        </div>
      </div>
  
    </div>

    
  
  </div>
  
  );
};

export default DashboardHeroPro;
